
bloomchic_sensor.abtest = sensors.use("SensorsABTest", {
  url: "https://abtest-aws-us-east-01.saas.sensorsdata.com/api/v2/abtest/online/results?project-key=39025CC34AF8603721600905A4A817BE28E819CD",
  timeout_milliseconds: 10000
});
sensors.abtest = bloomchic_sensor.abtest;

/** 首页AB测试 */
function homepageAB() {
  /** 处理AB结果 */
  function handleResult(result) {
  if (result == 'A') {
    $('.shopify-section-style[data-section-sensor-value="A"]').remove()
  }
  if (result == 'B') {
    $('.shopify-section-style[data-section-sensor-value="B"]').remove()
  }
}
  try {
    if (window.Bloom.abtest?.home_page.name) {
      /** 仅支持AB */
      bloomchic_sensor.abtest.fastFetchABTest({
        param_name: window.Bloom.abtest?.home_page.name,
        default_value: 'A',
        value_type: 'String',
        callback: function(result) {
          console.log('首页AB返回来的结果', result)
          handleResult(result);
        }
      });
    } else {
      handleResult('A');
    }
  } catch(err) {
    handleResult('A');
  }
}

homepageAB();

// Clear array
if (window.theme.section_ab_list && window.theme.section_ab_list.length) {
  window.theme.section_ab_list.forEach(function(item) {
    bloomchic_sensor.abtest.fastFetchABTest({
      param_name: item.id,
      default_value: item.default,
      value_type: 'String',
      callback: function(result) {
        item.callback(result);
      }
    })
  });
};
bloomchic_sensor.abtests.forEach(params => {
  bloomchic_sensor.abtest.fastFetchABTest(params)
});


